export const messages = {
  en: {
    feeRemind: {
      queryCondition: 'Query Conditions',
      hide: 'Hide',
      more: 'More',
      objNamePlaceholder: 'Please enter room number/contract name/license plate',
      ownerNamePlaceholder: 'Please enter owner name',
      linkPlaceholder: 'Please enter owner phone',
      feeConfigPlaceholder: 'Please select fee item',
      communityPlaceholder: 'Please select community',
      query: 'Query',
      reset: 'Reset',
      prePaymentRemind: 'Pre-payment Reminder',
      deadlineRemind: 'Expiration Reminder'
    },
    reportPrePaymentFee: {
      export: 'Export',
      feeId: 'Fee ID',
      objName: 'Room/Vehicle/Contract',
      feeName: 'Fee Item',
      startTime: 'Fee Start Time',
      oweDay: 'Days Until Start',
      tip: 'Note: This table shows fees starting within 7 days'
    },
    reportDeadlineFee: {
      export: 'Export',
      feeId: 'Fee ID',
      objName: 'Room/Vehicle/Contract',
      feeName: 'Fee Item',
      deadlineTime: 'Fee End Time',
      oweDay: 'Days Until End',
      tip: 'Note: This table shows fees ending within 7 days'
    }
  },
  zh: {
    feeRemind: {
      queryCondition: '查询条件',
      hide: '隐藏',
      more: '更多',
      objNamePlaceholder: '请填写房屋编号/合同名称/车牌号',
      ownerNamePlaceholder: '请填写业主名称',
      linkPlaceholder: '请填写业主手机号',
      feeConfigPlaceholder: '请选择费用项',
      communityPlaceholder: '请选择园区',
      query: '查询',
      reset: '重置',
      prePaymentRemind: '预缴费提醒',
      deadlineRemind: '到期提醒'
    },
    reportPrePaymentFee: {
      export: '导出',
      feeId: '费用编号',
      objName: '房号/车辆/合同',
      feeName: '费用项',
      startTime: '费用开始时间',
      oweDay: '距离开始时间(天)',
      tip: '温馨提示：此表反馈7天内开始缴费的费用'
    },
    reportDeadlineFee: {
      export: '导出',
      feeId: '费用编号',
      objName: '房号/车辆/合同',
      feeName: '费用项',
      deadlineTime: '费用结束时间',
      oweDay: '距离结束时间(天)',
      tip: '温馨提示：此表反馈7天内缴费结束的费用'
    }
  }
}